// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/****************  GET DATA VERIFICATION REPORT LIST START *********************** */
export const dataVerificationReportListGet = (listData: any) => {
	const data = {
		GetDataVerificationReportData: listData,
	};
	const url = `${API_URL}getDataVerificationDetailsForBranch`;
	return makeApiCall(url, data);
};
/****************  GET DATA VERIFICATION REPORT LIST END *********************** */
